import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalance.UploadFile.IRequest;
type Response = Api.Core.StatementBalance.UploadFile.IResponse;
type Headers = Api.Core.StatementBalance.UploadFile.IHeaders;
const apiStatementBalanceUploadFilePath = '/api/DealerManagement/StatementBalance/:id/UploadFile';
export default async function statementBalanceUploadFileApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiStatementBalanceUploadFilePath, { id }),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
